/**
 * @fliisi/pollen — Animations
 *
 * Shared animation configs. These are referenced by name
 * on any Tamagui component: <View animation="quick" />
 */
import { createAnimations } from '@tamagui/animations-css'

export const animations = createAnimations({
  // Near-instant (button press feedback)
  snap: 'ease-out 50ms',
  // Snappy interactions (button press, toggle)
  quick: 'ease-out 150ms',
  // Standard transitions (page elements, cards)
  moderate: 'ease-in-out 300ms',
  // Gentle movement (modals, sheets, fades)
  gentle: 'ease-in-out 450ms',
  // Slow float (background decorations, subtle)
  lazy: 'ease-in-out 600ms',
  // Tooltip-speed (instant feel)
  tooltip: 'ease-out 100ms',
})
